// extracted by mini-css-extract-plugin
module.exports = {"whyCars":"_17xj5","whyCarsText":"_21dCV","cmsTextWrapper":"_3MZwt"};